<template>
  <div>
    <div class="mt-20 grid-2-org" v-for="(user, index) in orgData" :key="index">
      <div v-if="user.direct_report > 0" class="flex-center ml-auto mr-20">
        <span class="direct-btn my-auto">{{ user.direct_report }} Direct Reports</span>
      </div>
      <div v-else></div>
      <div>
        <div class="flex-center">
          <div class="flex-mid">
            <div v-if="user.pic" :class="{ 'line-top-profile' : index != 0 }" class="flex-mid  mr-12">
              <img
                v-lazy="user.pic"
                :key="user.pic"
                class="image-skeleton image-profile-52 flex-mid"
                :class="[ blurMode ?  'blurelement': '' ]"
              />
            </div>
            <div
              v-else
              class="image image-profile-52 flex-mid mr-12"
              :class="{ 'line-top-profile' : index != 0 }"
            >
              <div
                class="text-in-image text-in-image-52 flex-mid"
                :class="[ blurMode ?  'blurelement': '' ]"
              >{{ $utils('acronymName', {firstName: user.firstname, lastName: user.lastname}) }}</div>
            </div>
          </div>
          <div class="flex-column mr-12">
            <span class="fs-16 fc-2D2E36"
            :class="[ blurMode ?  'blurelement': '' ]">{{ user.firstname }} {{ user.lastname }}</span>
            <span class="fs-12 fc-2D2E36 pt-2"
            :class="[ blurMode ?  'blurelement': '' ]" style="text-transform: uppercase;">{{ user.team_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orgMembers",
  props: ["orgData"],
  computed: {
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  }
}
</script>

<style lang="scss" scoped>
.direct-btn {
  font-size: 11px;
  color: #fff;
  background-color: #747474;
  border-radius: 7px;
  padding: 7px 14px;
  width: auto;
}
.grid-2-org {
  display: grid;
  grid-template-columns: 40% 60%;
}
.line-top-profile {
  position: relative;
  &:after {
    content: "";
    display: inline-block;
    position: absolute;
    top: -20px;
    z-index: 20;
    vertical-align: bottom;
    height: 20px;
    width: 1px;
    background: #E0E0E0;
  }
}
.flex-column {
  word-break: normal;
}
</style>